import { Injectable } from '@angular/core';
import {OrigemProvider} from "../origem/origem";
import {GenericStore} from "../../app/generic-store/generic-store";

interface Origem {
  descricaoOrigem: string;
  idOrigem: number;
  id: string;
}

interface IServiceResponse<T> {
  erro: string;
  data: T[] | null;
}

@Injectable({
  providedIn: 'root'
})
export class OrigemService {

  public origens: Origem[] = [];

  constructor(private origemProvider: OrigemProvider) { }

  async getOrigens(): Promise<IServiceResponse<Origem>>
  {
    try {

      if(this.origens.length)
      {
        return {
          erro: "",
          data: this.origens
        }
      }

      const response = await this.origemProvider.get();

      if(response.erro)
      {
        return {
          erro: response.erro,
          data: null
        }
      }

      this.origens = response.Item.map((origem) => {
        return {
          id: origem.idOrigem,
          idOrigem: origem.idOrigem,
          descricaoOrigem: origem.descricaoOrigem,
        }
      }) as any

      return {
        data: this.origens,
        erro: null
      }
    } catch (e) {
      return {
        erro: e.message,
        data: null
      }
    }
  }


}
